import React from "react";
import { Badge } from "react-bootstrap";
import { CommonButton, CommonInput, CommonSelect } from "../../Input";
import DataTable from "../../table/DataTable";

const HistoryTab = ({
  historyData,
  historyFilters,
  setHistoryFilters,
  onSearch,
  onReset,
  onViewDetails,
}) => {
  return (
    <div className="card shadow-none border-0 my-3 p-3 rounded-4 overflow-hidden history-tab">
      <DataTable
        columns={[
          { label: "ID", key: "id", className: "ps-4" },
          {
            label: "Date & Time",
            key: "dateTime",
            className: "ps-2",
            cellStyle: () => ({ whiteSpace: "pre-line" }),
          },
          {
            label: "Sender Name",
            key: "sender",
            className: "ps-2",
            render: (item) => (
              <div>
                <div className="fw-bold">{item.senderName}</div>
                <small className="text-muted">{item.senderEmail}</small>
              </div>
            ),
          },
          { label: "Receiver Name", key: "receiverName", className: "ps-2" },
          { label: "Payment Method", key: "paymentMethod", className: "ps-2" },
          { label: "Send Amount", key: "sendAmount", className: "ps-2" },
          {
            label: "Status",
            key: "status",
            className: "ps-2",
            render: (item) => (
              <Badge
                style={{
                  color: "#ffffff",
                  borderRadius: "6px",
                  backgroundColor:
                    item.status === "Approved" ? "#28C76F" : "#FF9F43",
                  padding: "6px 10px",
                }}
              >
                {item.status}
              </Badge>
            ),
          },
          {
            label: "Actions",
            key: "actions",
            className: "ps-4",
            render: (item) => (
              <div
                className="cursor-pointer text-muted hover-primary"
                onClick={() => onViewDetails(item)}
              >
                <i className="far fa-eye text-secondary fs-16"></i>
              </div>
            ),
          },
        ]}
        data={historyData}
      />
    </div>
  );
};

export default HistoryTab;
